import { FC } from 'react';
import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';
import { useTranslation } from 'react-i18next';
import { Alert, Skeleton } from '@mui/material';
import BackButton from '@/components/ui/BackButton/BackButton.tsx';
import { useParams } from 'react-router-dom';
import RouteParam from '@/_constants/RouteParam.ts';
import useReservations from '@/api/useReservations.ts';
import ReservationsTable from '@/components/functional/ReservationsTable/ReservationsTable.tsx';
import { passToRouteUrlParams } from '@/utils/passToRouteUrlParams.ts';
import Routes from '@/router/Routes.ts';

const RestaurantReservationsPage: FC = () => {
  const { t } = useTranslation();
  const routeParams = useParams();
  const restaurantId = parseInt(routeParams[RouteParam.RESTAURANT_ID]!);
  const {
    data: reservations,
    isLoading: isLoadingReservations,
    isError: isErrorReservations,
    error: errorReservations,
  } = useReservations(true, {
    restaurant_id: restaurantId,
  });

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap gap-4">
        <BackButton />
        {isLoadingReservations ? (
          <Skeleton variant="text" width={200} />
        ) : reservations && reservations[0]?.restaurant_id?.name ? (
          <h1 className="text-3xl font-medium m-0 font-ubuntu">{reservations[0].restaurant_id.name}</h1>
        ) : (
          <h1 className="text-3xl font-medium m-0 font-ubuntu">{t('pages.restaurantReservations.title')}</h1>
        )}
      </div>
      {isErrorReservations && <Alert severity="error">{errorReservations?.message}</Alert>}
      <div>
        <LoaderWrapper isLoading={isLoadingReservations}>
          <ReservationsTable
            rows={reservations ?? []}
            logsUrlGeneratorFn={(reservationId) =>
              passToRouteUrlParams(Routes.ADMIN__RESTAURANTS__RESERVATIONS__LOGS, {
                [RouteParam.RESTAURANT_ID]: `${restaurantId}`,
                [RouteParam.RESERVATION_ID]: reservationId,
              })
            }
          />
        </LoaderWrapper>
      </div>
    </div>
  );
};

export default RestaurantReservationsPage;
